import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { useAppSelector } from "../../../../../hooks/app";
import { ROLES } from "../../../../../constants";

function RepeatedSoloCrossCountry({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [conditions, setConditions] = React.useState("");
  const [directions, setDirections] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required training in both directions between and at both ${directions} I have determined that [he or she] is proficient of §61.93(b)(2) to conduct repeated solo cross-country flights over that route, subject to the following conditions: ${conditions}`;
    dispatch(setTemplateText(templateText));
  }, [name, conditions, directions, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.103(f), 61.107(b), and 61.109</label>
      </div>
      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that{" "}
          <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training in both directions between and at both
          <input
            type="text"
            onChange={(e) => setDirections(e.target.value)}
            style={{ margin: '0 5px' }}
          /> I have determined that [he or she] is proficient of §61.93(b)(2) to conduct repeated solo cross-country flights over that route, subject to the following conditions: <input
            type="text"
            onChange={(e) => setConditions(e.target.value)}
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default RepeatedSoloCrossCountry;
